// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path fill-rule="evenodd" d="M7.82 3.37A2 2 0 0 1 9.72 2H14.28A2 2 0 0 1 16.18 3.37L16.72 5H20A1 1 0 1 1 20 7H19.94L19.13 19.2A3 3 0 0 1 16.13 22H7.87A3 3 0 0 1 4.88 19.2L4.06 7H4A1 1 0 0 1 4 5H7.28ZM14.61 5H9.39L9.72 4H14.28ZM9 10A1 1 0 0 1 10 11V17A1 1 0 1 1 8 17V11A1 1 0 0 1 9 10M15 10A1 1 0 0 1 16 11V17A1 1 0 1 1 14 17V11A1 1 0 0 1 15 10" clip-rule="evenodd"/>';

/** Trash (actions). */
const icon: IconData = {
  id: "trash",
  name: "Trash",
  category: "actions",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 6L5.88 19.13A2 2 0 0 0 7.87 21H16.13A2 2 0 0 0 18.13 19.13L19 6M8 6L8.77 3.68A1 1 0 0 1 9.72 3H14.28A1 1 0 0 1 15.23 3.68L16 6M10 11V16M14 11V16M4 6H20"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M14.28 2L15.04 2.15 15.57 2.47 15.97 2.94 16.18 3.37 16.72 5H20L20.39 5.08 20.72 5.3 20.93 5.64 21 6.03 20.91 6.42 20.67 6.74 20.33 6.94 19.94 7 19.1 19.38 18.9 20.12 18.74 20.46 18.3 21.05 18.04 21.3 17.41 21.7 17.07 21.84 16.13 22 7.68 21.98 6.93 21.84 6.58 21.7 5.97 21.3 5.7 21.05 5.27 20.46 5.1 20.12 4.88 19.2 4.07 7 3.61 6.92 3.28 6.7 3.07 6.36 3 5.97 3.09 5.58 3.33 5.26 3.67 5.06 4 5H7.28L7.88 3.21 8.21 2.69 8.69 2.29 9.25 2.06 9.72 2Z"/></g><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 6L5.88 19.13A2 2 0 0 0 7.87 21H16.13A2 2 0 0 0 18.13 19.13L19 6M8 6L8.77 3.68A1 1 0 0 1 9.72 3H14.28A1 1 0 0 1 15.23 3.68L16 6M10 11V16M14 11V16M4 6H20"/>',
    },
  },
  animation: () => import("../animations/trash.js"),
};

export default icon;
